import React, { useState } from 'react';
import { IFilterableField } from './filters';
import SearchBar from '../SearchBar/SearchBar';
import styles from './FilterableFieldList.module.scss';
import backIcon from 'v2/icons/angle.svg';
import backButtonStyles from './BackButton.module.scss';
import classnames from 'classnames';

interface IFilterableFieldProps extends IFilterableField {
  onFieldClicked: (field: IFilterableField) => void;
}

const FilterableField = ({
  onFieldClicked,
  ...field
}: IFilterableFieldProps) => {
  return (
    <button
      className={classnames(styles.field)}
      onClick={() => onFieldClicked(field)}
    >
      {field.displayName}
    </button>
  );
};

function matchesFieldnameOrDisplayName(
  currentSearch: string,
  field: IFilterableField
) {
  const match = new RegExp(currentSearch, 'ig');

  return (
    field.displayName.match(match)?.length || field.name.match(match)?.length
  );
}

interface IFilterFieldList
  extends Pick<IFilterableFieldProps, 'onFieldClicked'> {
  filterableFields: IFilterableField[];
  hasAppliedFilters: boolean;
  onClickBack: () => void;
}

export const FilterableFieldList = ({
  filterableFields,
  hasAppliedFilters,
  onClickBack,
  onFieldClicked,
}: IFilterFieldList) => {
  const [currentSearch, setCurrentSearch] = useState<string>('');

  const handleSearch = (search: string) => {
    setCurrentSearch(search);
  };

  const displayList = filterableFields.filter((f) =>
    matchesFieldnameOrDisplayName(currentSearch, f)
  );

  return (
    <div className={styles.fieldList}>
      {hasAppliedFilters ? (
        <button
          className={classnames(styles.back, backButtonStyles.back)}
          onClick={onClickBack}
        >
          <img src={backIcon} alt="back" />
          Back
        </button>
      ) : (
        <div className={styles.emptyMessage}>
          This view has no advanced filters. Add filters below.
        </div>
      )}
      <SearchBar
        onSearch={handleSearch}
        currentText={currentSearch}
        placeHolder={'Search'}
        lengthTextValidation={{
          number: -1,
          operator: '>',
          debounce: 250,
        }}
        classNameBar={styles.search}
      />
      <div className={classnames(styles.list, 'nomadScrollbar2')}>
        {displayList.map((field) => (
          <FilterableField
            key={field.name}
            onFieldClicked={onFieldClicked}
            {...field}
          />
        ))}
      </div>
    </div>
  );
};
